import { render } from "./breakdown.vue?vue&type=template&id=574cf63f&scoped=true"
import script from "./breakdown.vue?vue&type=script&lang=js"
export * from "./breakdown.vue?vue&type=script&lang=js"

import "./breakdown.vue?vue&type=style&index=0&id=574cf63f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574cf63f"]])

export default __exports__